import { GridColDef } from '@mui/x-data-grid';
import { useMemo } from 'react';
import { addItemsBaseColumnProps } from './useAddItemsBaseColumns';
import { dataGridBoldClass } from '@shared/styles';
import { useAppTFunction } from '@retail/app/i18n';
import { useFormContext } from 'react-hook-form';
import { AddCampaignItemsSchema, BaseCampaignItemSchema } from './addItemsSchema';
import { BaseMgSupplierCampaignItem } from '@retail/campaign/types';
import { PriceInput } from './PriceInput';

export const usePurchasePriceColumns = () => {
  const t = useAppTFunction();

  const {
    control,
    formState: { errors },
  } = useFormContext<AddCampaignItemsSchema<BaseCampaignItemSchema>>();

  return useMemo(() => {
    const getCampaignPurchasePriceColumn = (): GridColDef<BaseMgSupplierCampaignItem> => ({
      ...addItemsBaseColumnProps,
      flex: 1,
      minWidth: 195,
      cellClassName: () => dataGridBoldClass,
      field: 'campaignPurchasePrice',
      headerName: t('campaign.columns.campaignPurchasePrice.label'),
      renderCell: ({ row }) => {
        const error = errors.items?.[row.mgSupplierItemId]?.campaignPurchasePrice;

        return (
          <PriceInput
            error={error?.message}
            fieldName={`items.${row.mgSupplierItemId}.campaignPurchasePrice`}
            control={control}
            incVat={false}
          />
        );
      },
    });

    return { getCampaignPurchasePriceColumn };
  }, [control, errors.items, t]);
};
